module.exports = __webpack_public_path__ + "static/media/newsletter-december-2023-5.69c7240e.jpg";